<div [class]="themeClass">
  <router-outlet></router-outlet>
  <router-outlet name="dialog"></router-outlet>
</div>
